export default "__VITE_ASSET__CXh8vJVe__"